import React from 'react';
import { benefits, companyInfo } from '../data';
import * as LucideIcons from 'lucide-react';
import { motion } from 'framer-motion';

export default function Benefits() {
  return (
    <section id="fordele" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <h2 className="text-slate-500 font-bold tracking-widest uppercase text-sm mb-4">Hvorfor vælge Coating?</h2>
          <h3 className="text-4xl md:text-5xl font-black text-slate-900 mb-6 leading-tight uppercase">
            Gør din hverdag nemmere med Keramisk Coating
          </h3>
          <p className="text-lg text-slate-600">
            Det handler ikke kun om at have en pæn bil – det handler om at spare tid, beskytte din investering og få ro i maven.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = LucideIcons[benefit.icon] || LucideIcons.Zap;
            return (
              <motion.div 
                key={index} 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group p-8 rounded-3xl bg-slate-50 border border-slate-100 hover:bg-white hover:shadow-2xl hover:shadow-slate-900/5 transition-all duration-300"
              >
                <div className="w-14 h-14 rounded-2xl bg-slate-200 flex items-center justify-center text-slate-900 mb-6 group-hover:bg-slate-900 group-hover:text-white transition-colors">
                  <Icon size={28} />
                </div>
                <h4 className="text-xl font-bold text-slate-900 mb-4 uppercase">{benefit.title}</h4>
                <p className="text-slate-600 leading-relaxed">
                  {benefit.description}
                </p>
              </motion.div>
            );
          })}
        </div>

        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-16 p-8 rounded-[2.5rem] bg-slate-900 text-white overflow-hidden relative"
        >
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="max-w-xl">
              <h4 className="text-2xl font-bold mb-2 uppercase">Er du i tvivl om hvad der passer til din bil?</h4>
              <p className="text-slate-400">Vi tilbyder altid gratis rådgivning og sparring omkring den bedste løsning for netop din bil.</p>
            </div>
            <a 
              href={`tel:${companyInfo.phone}`}
              className="bg-white text-slate-900 px-8 py-4 rounded-full font-bold hover:bg-slate-100 transition-all shrink-0 active:scale-95"
            >
              Ring og få en snak
            </a>
          </div>
          {/* Subtle background glow */}
          <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 w-64 h-64 bg-slate-500/10 blur-[100px] rounded-full" />
        </motion.div>
      </div>
    </section>
  );
}
